export default __webpack_public_path__ + "static/bg-pandas-profiling-a6d1e0c67f9504a277931e5ea5e740e7.jpg";